export enum ModelName {
  ACTION = 'Action',
  BOARD = 'Board',
  BOARD_PLUGIN = 'BoardPlugin',
  CARD = 'Card',
  CHECKLIST = 'Checklist',
  CUSTOM_FIELD = 'CustomField',
  CUSTOM_FIELD_ITEM = 'CustomFieldItem',
  ENTERPRISE = 'Enterprise',
  LABEL = 'Label',
  LIST = 'List',
  MEMBER = 'Member',
  NOTIFICATION = 'Notification',
  NOTIFICATION_GROUP = 'NotificationGroup',
  ORGANIZATION = 'Organization',
  PENDING_ORGANIZATION = 'PendingOrganization',
  PLUGIN = 'Plugin',
  PLUGIN_DATA = 'PluginData',
  REACTION = 'Reaction',
}
